export const primeiraImagemBanner = "Primeira imagem do banner";
export const segundaImagemBanner = "Sugunda imagem do banner";
export const terceiraImagemBanner = "Terceira imagem do banner";
export const imagensSessaoVitrinePrimeiro = "Primeira imagem da vitrine";
export const imagensSessaoVitrinesegundo = "Segunda imagem da vitrine";
export const imagensSessaoBanner = "Imagem Banner";
export const imagensSessaoVitrine = "Imagem Vitrine";
export const TextoVitrine = "Textos da vitrine";
export const Editor = "Descrição";
export const EditorPlaceHolder = "Digite seu texto para a vitrine em até 2000 caracteres.*";
export const SessaoImagens = "Imagens";
export const SessaoTitulos = "Títulos";
export const SessaoTexto = "Texto";
export const ModalTexto = "Deseja remover esse item?";
export const UrlBuscarPaginado = "Portifolio/BuscarPaginado";
export const UrlPortifolio = "Portifolio";

export const propertyLabelsLoja: { [key: string]: { label: string; ordem?: number }; } = {
    titulo: { label: "Titulo", ordem: 2 },
    subTitulo: { label: "SubTitulo", ordem: 3 },
    razaoSocial: { label: "Razão Social", ordem: 1 }

};

export const propertyLabelsColaborador: { [key: string]: { label: string; ordem?: number }; } = {
    titulo: { label: "Titulo", ordem: 2 },
    subTitulo: { label: "SubTitulo", ordem: 3 },
    nomeColaborador: { label: "Nome", ordem: 1 }

};

export const UrlTipoPortifolioImagem = "TipoPortifolio";

